import { fetchSession } from "@common/api/desktop/sessions";
import DataGrid from "@common/components/shared/DataGrid";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Checkbox,
  Dimmer,
  Grid,
  Header,
  Loader,
  Message,
  Modal,
} from "semantic-ui-react";

const SessionDetailsModal = ({ sessionId, modalOpen, handleClose, logIn }) => {
  const [data, setData] = useState({
    loading: false,
    showGamePlayEvents: false,
    session: {
      eventsGrid: {
        headerDef: [],
        rowDef: [],
        data: [],
      },
      summarysGrid: {
        headerDef: [],
        rowDef: [],
        data: [],
      },
    },
  });

  const { session, showGamePlayEvents, loading } = data;
  const { summarysGrid, eventsGrid, suspiciousReason } = session;

  useEffect(() => {
    if (!sessionId || !modalOpen) {
      return;
    }
    setData((data) => {
      return { ...data, loading: true };
    });
    fetchSession(sessionId, showGamePlayEvents).then(
      (session) =>
        setData((data) => {
          return { ...data, session, loading: false };
        }),
      () =>
        setData((data) => {
          return { ...data, loading: false };
        }),
    );
  }, [sessionId, showGamePlayEvents]);

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      size="fullscreen"
      closeIcon
      className="h-80"
    >
      <Header content={`Session Details ${sessionId}`} />
      <Modal.Content className="h-100">
        {loading ? (
          <Dimmer active inverted>
            <Loader inverted inline="centered" active />
          </Dimmer>
        ) : (
          <Grid className="height-100 flex-container">
            {session.isSuspicious && suspiciousReason && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <Message negative>{suspiciousReason}</Message>
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column width="16">
                <b>{session.site}</b> - {session.gameName}
                {logIn.optionShowPlayerID && (
                  <span className="ml-2">
                    <b>CUSTOMER ID:</b> {session.playerID || "N/A"}
                  </span>
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="16">
                <b>SESSION START:</b> {session.startDate}
                <span className="ml-2">
                  <b>SESSION END:</b> {session.endDate}
                </span>
                <span className="ml-2">
                  <b>DURATION (HH:MM)</b> {session.duration || "N/A"}
                </span>
                <Checkbox
                  className="ml-2"
                  label="Show Game Play Events"
                  onClick={() =>
                    setData({
                      ...data,
                      showGamePlayEvents: !showGamePlayEvents,
                    })
                  }
                  checked={showGamePlayEvents}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column width={4} stretched>
              <div className="table-overflow flex-stretch-vertical">
                <DataGrid
                  fullHeight
                  headings={summarysGrid.headerDef}
                  rowDef={summarysGrid.rowDef}
                  data={summarysGrid.data}
                  onRowClick={function () {}}
                />
              </div>
              </Grid.Column>
              <Grid.Column width={12} stretched>
              <div className="table-overflow flex-stretch-vertical">
                <DataGrid
                  headings={eventsGrid.headerDef}
                  rowDef={eventsGrid.rowDef}
                  fullHeight
                  data={eventsGrid.data}
                  onRowClick={function () {}}
                />
              </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, null)(SessionDetailsModal);
